import { useCallback, useEffect, useRef, useState } from 'react';
import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Botao } from '../../../components/Botao';
import { CorpoDaPagina } from '../../../components/CorpoDaPagina';
import { Input } from '../../../components/Input';
import TextArea from '../../../components/TextArea';
import { EmailStore } from '../../../stores/EmailStore';
import { Conteiner, ConteinerBotoes, Formulario, LinhaFormulario } from './styles';

function FormularioRecusa() {
  const [solicitacoes, atribuirSolicitacoes] = useState([]);

  const formularioRecusa = useRef(null);

  const { pathname } = useLocation();

  const historico = useHistory();

  const enviarFormulario = useCallback(
    async (data) => {
      let error = false;
      const solicitacao = {};

      for (const chave in data.justificativa) {
        const id = parseInt(chave);
        const justificativa = data.justificativa[chave];

        if (justificativa.trim().length < 10) {
          if (justificativa === '') {
            formularioRecusa.current?.setFieldError(`justificativa[${chave}]`, 'Campo obrigatório');
            error = true;
          } else {
            formularioRecusa.current?.setFieldError(
              `justificativa[${chave}]`,
              'Preenchimento mínimo de 10 caracteres.',
            );
            error = true;
          }
        }

        solicitacao[id] = {
          id,
          justificativa,
        };
      }

      if (error) {
        return;
      } else {
        const solicitacoesFormatado = Object.keys(solicitacao).map((chave) => ({
          id: solicitacao[chave].id,
          justificativa: solicitacao[chave].justificativa,
        }));

        await EmailStore.recusarEmail(solicitacoesFormatado).then((response) => {
          if (response.status === 200) {
            if (solicitacoesFormatado.length > 1) {
              toast.success('Análise finalizada. E-mails reprovados com sucesso!');
            } else {
              toast.success('Análise finalizada. E-mail reprovado com sucesso!');
            }
            historico.push('/home');
          } else {
            toast.error(response.data.mensagem);
          }
        });
      }
    },
    [historico],
  );

  useEffect(() => {
    const parametros = pathname.split('/').pop();
    const idsArray = parametros.split('&').map((id) => Number(id));

    const response = EmailStore.obterPorListaDeId(idsArray);

    response
      .then((resultado) => {
        atribuirSolicitacoes(resultado.data);
      })
      .catch(() => {
        toast.error('Não foi possivel obter os dados da(s) instituição(ões).');
        historico.goBack();
      });
  }, [pathname]);

  return (
    <CorpoDaPagina titulo={'Análise de solicitação de cadastro de e-mail'} voltar>
      <Conteiner>
        <Formulario ref={formularioRecusa} onSubmit={enviarFormulario}>
          {solicitacoes.map((item) => {
            return (
              <React.Fragment key={item.id}>
                <LinhaFormulario>
                  <Input
                    titulo='Nome da instituição'
                    nome={'instituicaoEnsinoNome'}
                    desabilitado
                    value={item.instituicaoDeEnsinoNome}
                  />
                  <Input titulo='E-mail' nome={'email'} desabilitado value={item.email} />
                </LinhaFormulario>

                <TextArea
                  titulo='Justificativa'
                  nome={`justificativa[${item.id}]`}
                  tipo='text'
                  placeholder={'Informe o motivo da reprovação'}
                />
                <hr />
              </React.Fragment>
            );
          })}

          <ConteinerBotoes>
            <Botao
              texto='Cancelar'
              cor='medium'
              aoClicar={() => {
                historico.push('/home');
              }}
              tipo='button'
            />
            <Botao tipo='submit' texto='Salvar' cor='primary' outlined />
          </ConteinerBotoes>
        </Formulario>
      </Conteiner>
    </CorpoDaPagina>
  );
}

export default FormularioRecusa;
